var map = {
	"./Copy.vue": 57989,
	"./DownloadList.vue": 4046,
	"./Famous.vue": 69341,
	"./FamousInfo.vue": 18749,
	"./Floorplan.vue": 62501,
	"./History.vue": 20270,
	"./Index.vue": 68010,
	"./News.vue": 94795,
	"./NewsInfo.vue": 59695,
	"./NotFound.vue": 83895,
	"./SinglePage.vue": 48571,
	"./UserChangePassword.vue": 92032,
	"./UserEdit.vue": 71731,
	"./UserExhibition.vue": 99860,
	"./UserForgotPassword.vue": 60553,
	"./UserLogin.vue": 27110,
	"./UserLogout.vue": 89917,
	"./UserRegister.vue": 45768,
	"./UserReserve.vue": 13629,
	"./UserReserveInfo.vue": 71613,
	"./VueCropper - 副本.vue": 86185,
	"./VueCropper.vue": 62485,
	"./upload-cropper.vue": 32281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99508;